<template>
  <modal
    :show="showEditDestinationModal"
    modal-classes="modal-dialog-centered modal-sm"
    @close="closeEditDestinationModal('close')"
    no-close-on-backdrop
  >
    <template slot="header">
      <h4 class="subtitle">Edit Destination</h4>
    </template>
    <div class="mt-3">
      <div class="row">
        <div class="col-12 border-bottom mb-4 ">
          <div class="data-block">
            <span class="title-block">Destination</span>
            <span class="content-block">{{ tempBranchName }}</span>
          </div>
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <BaseNumberInput
            v-model.number="$v.tempBranch.selection_range.$model"
            id="selection_range"
            name="selection_range"
            label="Service Coverage Radius"
            placeholder="Service Coverage Radius"
            markrequired
            :error="
              $v.tempBranch.selection_range.$error
                ? `Enter from 5Km and to 250Km`
                : ''
            "
          />
        </div>
      </div>
    </div>

    <template slot="footer">
      <div class="row">
        <div class="col-6 text-center pl-0">
          <base-button
            type="outline-neutral mb-0 "
            class="min-button"
            @click="closeEditDestinationModal('close')"
            ><i class="flaticon-cancel"></i>Cancel</base-button
          >
        </div>
        <div class="col-6 text-center">
          <base-button
            type="primary"
            class="min-button mb-0"
            @click="saveDestination"
            ><i class="flaticon-floppy-disk"></i>Save</base-button
          >
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { BranchesAPI } from "../../../../core/api";
import { required, numeric } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import lodash from "lodash";
import { setSigOut } from "../../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "EditDestinations",
  components: {
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    branch: {
      type: Object,
      required: true
    },
    branchId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showEditDestinationModal: false,
      tempBranch: {
        name: "",
        supplier: "",
        country_code: "",
        timezone: "",
        geometry: {
          location: {
            lat: 0,
            lng: 0
          }
        },
        selection_range: 45,
        destination: {
          city: "",
          country: {},
          languages: [],
          location: {},
          slug: "",
          state: {},
          time_zone: "",
          iata_code: "",
          geometry: {
            type: "Polygon",
            coordinates: []
          },
          exceptions: []
        }
      },
      tempBranchId: "",
      tempBranchName: "",
      selects_hours: [1, 5, 10, 15, 24, 36, 48],
      cancelationsOptions: [1, 12]
    };
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showEditDestinationModal = current;
      },
      deep: true
    },
    branchId: {
      handler: function(current, old) {
        if (current) {
          this.tempBranchId = current;
        }
      },
      deep: true
    },
    branch: {
      handler: function(current, old) {
        if (!lodash.isEmpty(current)) {
          this.populateBranch(current);
        }
      },
      deep: true
    }
  },
  async created() {
    this.tempBranchId = this.branchId;
    if (!lodash.isEmpty(this.branch)) {
      this.populateBranch(this.branch);
    }
    this.cancelationsOptions = this.cancelationsOptions.concat(
      Array.from({ length: 30 }, (_, index) => (index + 1) * 24)
    );
  },
  methods: {
    async saveDestination() {
      if (!this.$v.tempBranch.$invalid) {
        let branch = lodash.cloneDeep(this.tempBranch);
        await this.updateDestination(this.tempBranchId, branch);
      } else {
        this.$v.tempBranch.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateDestination(branchId, branch) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.updateBranchById(
          branchId,
          branch,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Destination has been updated",
            icon: "flaticon-check-3"
          });
          this.closeEditDestinationModal("updated");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving the Destination, please try again"
        );
      }
    },
    populateBranch(branch) {
      this.tempBranch.name = branch.name;
      this.tempBranchName = branch.name;
      this.tempBranch.supplier = branch.supplier._id;
      this.tempBranch.country_code = branch.country_code;
      this.tempBranch.geometry.location = branch.geometry.location;
      this.tempBranch.selection_range = branch.selection_range;
      this.tempBranch.timezone = branch.timezone;
      this.tempBranch.destination = {
        city: branch.destination.city,
        country: branch.destination.country,
        languages: branch.destination.languages,
        location: branch.destination.location,
        slug: branch.destination.slug,
        state: branch.destination.state,
        time_zone: branch.destination.time_zone,
        iata_code: branch.destination.iata_code,
        geometry: branch.destination.geometry,
        exceptions: branch.destination.exceptions
      };
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    closeEditDestinationModal(action = "close") {
      this.showEditDestinationModal = false;
      this.restartData();
      this.$emit("close", action);
    },
    restartData() {
      this.tempBranch = {
        name: "",
        supplier: "",
        country_code: "",
        timezone: "",
        geometry: {
          location: {
            lat: 0,
            lng: 0
          }
        },
        selection_range: 45,
        destination: {
          city: "",
          country: {},
          languages: [],
          location: {},
          slug: "",
          state: {},
          time_zone: "",
          iata_code: "",
          geometry: {
            type: "Polygon",
            coordinates: []
          },
          exceptions: []
        }
      };
      this.tempBranchId = "";
      this.tempBranchName = "";
      this.$v.tempBranch.$reset();
    },
    getTimeFormat(time) {
      if (time >= 1 && time <= 12) {
        return time === 1 ? `${time} hour` : `${time} hours`;
      } else {
        return time / 24 === 1 ? `${time / 24} day` : `${time / 24} days`;
      }
    },
    ...mapMutations(["setSigOut", "setLoad"]),
    ...mapActions([])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    tempBranch: {
      destination: {
        slug: {
          required
        }
      },
      selection_range: {
        required,
        numeric,
        customValidator: function(value) {
          return value >= 5 && value <= 250;
        }
      }
    }
  }
};
</script>
